import "bootstrap/dist/css/bootstrap.css";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import {
  ToastsContainer,
  ToastsContainerPosition,
  ToastsStore,
} from "react-toasts";
import ForgotPassword from "./Auth/ForgotPassword";
import Login from "./Auth/Login";
import Logout from "./Auth/Logout";
import Attrition from "./Pages/Attrition";
import BomChecklist from "./Pages/BomChecklist";
import BomPage from "./Pages/BomPage";
import History from "./Pages/History";
import Home from "./Pages/Home";
import PackageLeadType from "./Pages/PackageLeadType";
import Profile from "./Pages/Profile";
import SystemSetting from "./Pages/SystemSetting";
import User from "./Pages/User";
import Vendor from "./Pages/Vendor";

const App = ({ user }) => (
  <React.Fragment>
    <ToastsContainer
      position={ToastsContainerPosition.TOP_RIGHT}
      store={ToastsStore}
    />
    <Switch>
      <Route exact path="/login" component={Login} />
      <Route exact path="/logout" component={Logout} />
      <Route exact path="/forgotpassword" component={ForgotPassword} />
      {user.token ? (
        <React.Fragment>
          <Route exact path="/" component={Home} />
          <Route exact path="/user" component={User} />
          <Route exact path="/bomChecklist" component={BomChecklist} />
          <Route exact path="/vendor" component={Vendor} />
          <Route exact path="/attritions" component={Attrition} />
          <Route exact path="/packageLeadTypes" component={PackageLeadType} />
          <Route exact path="/profile" component={Profile} />
          <Route exact path="/history" component={History} />
          <Route exact path="/history/:id" component={BomPage} />
          <Route exact path="/systemSettings" component={SystemSetting} />
        </React.Fragment>
      ) : (
        <Redirect to="/login" />
      )}
    </Switch>
  </React.Fragment>
  // </Suspense>
);

App.propTypes = {
  user: PropTypes.shape({}).isRequired,
};

export default withRouter(connect((state) => ({ user: state.user }))(App));
